module.exports = __webpack_public_path__ + "assets/img/33_769_big.fa87d80a.jpg";